module.exports = __webpack_public_path__ + "img/scroll.9a504897.svg";